export default __webpack_public_path__ + "static/media/BLE_PULSE_DELIVERED.fc6387b9.png";